export const novosIndicadores = [
  'iProtegidasImp',
  'porcMuBra',
  'porcMuLider',
  'porcPcdBrasil',
  'porcPcdLider',
  'porcPrePardas',
  'porcPreLider',
  'porcLgbt',
  'porcLgbtLider',
  'porcEmpMap',
  'porcTemas100',
  'porcEmpResp',
  'porcEmpComun',
  'porcForunsMap',
  'porcEmpPlano',
  'porcPartForuns',
  'porcMedioCont',
  'porcEmpOds',
  'porcEmpAdocao',
  'pedTech',
  'investPedTech',
  'consAguaProd',
  'consAgua',
  'consEnergiaCon',
  'consEnergiaProd',
];

export const indicadoresComTotal = [
  'porcEmpMap',
  'porcTemas100',
  'porcEmpResp',
  'porcEmpComun',
  'porcForunsMap',
  'porcEmpPlano',
  'porcPartForuns',
  'porcEmpOds',
  'porcEmpAdocao'
];
